export const ACTIONS = [
    {
        value: 'SMS',
        text: 'SMS',
    },
    {
        value: 'EMAIL',
        text: 'Email',
    },
    {
        value: 'PUSH',
        text: 'Push Notification',
    },    
];

export const PROPERTIES_CHANNELS_SELECT_TYPE = [
    {
        value: 1,
        text: 'Only Send',
    },
    {
        value: 0,
        text: 'Do Not Send',
    },
    {
        value: 2,
        text: 'Send For All',
    },
];

export const EDITOR_URL = 'https://cdn.ckeditor.com/4.19.0/full/ckeditor.js';

export const TOOLBAR = [
    {
        name: 'clipboard',
        items: [
            'Cut',
            'Copy',
            'Paste',
            'PasteText',
            'PasteFromWord',
            '-',
            'Undo',
            'Redo',
        ],
    },
    {
        name: 'editing',
        items: ['Find', 'Replace', 'SelectAll'],
    },
    {
        name: 'tools',
        items: ['ShowBlocks'],
    },
    { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
    {
        name: 'insert',
        items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar'],
    },
    { name: 'document', items: ['Source'] },
    '/',
    {
        name: 'basicstyles',
        items: ['Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat'],
    },
    {
        name: 'paragraph',
        items: [
            'NumberedList',
            'BulletedList',
            '-',
            'Outdent',
            'Indent',
            '-',
            'JustifyLeft',
            'JustifyCenter',
            'JustifyRight',
            'JustifyBlock',
        ],
    },
    {
        name: 'styles',
        items: ['Styles', 'Format', 'FontSize', 'Font', 'TextColor'],
    },
    { name: 'colors' },
    '/',
];

export const FONT_NAMES =
    "Lato/'Lato' , sans-serif;Arial/Arial, Helvetica, sans-serif;Arial Unicode/ArialUnicode;Comic Sans MS/Comic Sans MS, cursive;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif";

export const RIGHT_BUTTON_2_CONFIG = {
    variant: 'primary',
    text: 'Insert Tag',
};

export const RIGHT_BUTTON_CONFIG = {
    icon: ['fas', 'arrow-down'],
    variant: 'primary',
};

export const AIRBNB_RESERVATION_ALTERATION_REQUEST_IDENTIFIER = 'AIRBNB_RESERVATION_ALTERATION_REQUEST';
export const AUTOMATED_PAYMENT_IDENTIFIER = 'AUTOMATED_PAYMENT';
export const DAMAGE_NOTICE_IDENTIFIER = 'DAMAGE_NOTICE';
export const TRAVEL_INSURANCE_PURCHASED_STATUS = 1;
export const HAS_PETS_STATUS = 1;
export const HAS_NO_PETS_STATUS = 0
export const PETS_IDENTIFIER = 'PETS';
export const RECURRING_IDENTIFIER = 'RECURRING';
export const INVOICE_STATUS_IDENTIFIER = 'INVOICE_STATUS';
export const DATE_IDENTIFIER = 'DATE';
export const TRAVEL_INSURANCE_IDENTIFIER = 'TRAVEL_INSURANCE';
export const EQUAL_TO_OPERATOR = { value: 'EQUAL_TO', text: 'Equal To' };
export const NOT_EQUAL_TO_OPERATOR = { value: 'NOT_EQUAL_TO', text: 'Not Equal To' };
export const DAY_OF_THE_WEEK = 'DAY_OF_THE_WEEK';
export const OWNER_BLOCK_IDENTIFIER = 'OWNER_BLOCK';
export const INVOICE_PAYMENT_IDENTIFIER = 'INVOICE_PAYMENT';
export const PAYMENT_REQUEST_IDENTIFIER = 'PAYMENT_REQUEST';
export const WORK_ORDER_IDENTIFIER = 'WORK_ORDER';
export const WORK_ORDER_SOURCE_IDENTIFIER = 'WORK_ORDER_SOURCE';
export const ARRIVAL_DATE_RANGE = 'ARRIVAL_DATE_RANGE';
export const DEPARTURE_DATE_RANGE = 'DEPARTURE_DATE_RANGE';
export const GUEST_STATUS_IDENTIFIER = 'GUEST_STATUS'
const CHANGED_TO_OPERATOR = { value: 1, text: 'Changed To' };
const CHANGED_FROM_OPERATOR = { value: 0, text: 'Changed From' };

export const eventOperatorOptions = {
    AIRBNB_RESERVATION_ALTERATION_REQUEST: [EQUAL_TO_OPERATOR],
    INVOICE_STATUS: [CHANGED_TO_OPERATOR, CHANGED_FROM_OPERATOR],
    RENTAL_AGREEMENT: [CHANGED_TO_OPERATOR],
    ARRIVAL_DATE_PAST: [EQUAL_TO_OPERATOR],
    ARRIVAL_DATE_FUTURE: [EQUAL_TO_OPERATOR],
    AUTOMATED_PAYMENT: [EQUAL_TO_OPERATOR],
    DEPARTURE_DATE_PAST: [EQUAL_TO_OPERATOR],
    DEPARTURE_DATE_FUTURE: [EQUAL_TO_OPERATOR],
    OWNER_BLOCK: [EQUAL_TO_OPERATOR],
    CLEAN_STATUS: [CHANGED_TO_OPERATOR],
    RENTAL_AGREEMENT: [CHANGED_TO_OPERATOR],
    DATE: [EQUAL_TO_OPERATOR],
    DAY_OF_THE_WEEK: [CHANGED_TO_OPERATOR],
    INVOICE_PAYMENT: [EQUAL_TO_OPERATOR],
    PAYMENT_REQUEST: [EQUAL_TO_OPERATOR],
    DAMAGE_NOTICE: [EQUAL_TO_OPERATOR],
    WORK_ORDER: [EQUAL_TO_OPERATOR],
    STAYLIO_GUEST_APP: [EQUAL_TO_OPERATOR],
};
